import axios, { encodeData } from "../utils/axios";

export const fetchShips = async (
  resultsPerPage,
  page,
  search,
  orderBy,
  orderDirection
) => {
  const res = await axios
    .get("/ship/", {
      params: { resultsPerPage, page, search, orderBy, orderDirection },
    })
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });

  return res.data;
};

export const createShip = async (newShip) => {
  await axios.post("/ship/create", encodeData(newShip));
};

export const updateShip = async (updateShip) => {
  await axios.put("/ship/update", encodeData(updateShip));
};

export const deleteShip = async (deleteShip) => {
  await axios.delete("/ship/delete", {
    data: encodeData(deleteShip),
  });
};
